import { Component, Input } from '@angular/core';

import {
  ListenSpalte,
  ListenStruktur,
  spaltenDatentypText,
  strukturSpalten
} from '../../../../../Models/messstelle.model';


/**
 * Kompakte, rein lesende Darstellung einer Spaltenstruktur: Spalten in
 * Reihenfolge, Datentyp, Pflicht und – hervorgehoben – die Kennzeichnung.
 * Wird bei der Vorlagenauswahl und in der Vorlagenverwaltung gezeigt.
 */
@Component({
  selector: 'app-struktur-vorschau',
  template: `
    <div class="vorschau" *ngIf="spalten.length > 0; else leer">
      <div class="vorschau-spalte" *ngFor="let s of spalten" [class.vorschau-kennz]="s.istKennzeichnung"
        [matTooltip]="tooltip(s)">
        <span class="vorschau-name">
          <mat-icon inline *ngIf="s.istKennzeichnung" class="kennz-icon">key</mat-icon>
          {{ s.name }}<span class="vorschau-pflicht" *ngIf="s.pflicht" aria-label="Pflichtfeld">*</span>
        </span>
        <span class="vorschau-typ">{{ typText(s) }}</span>
      </div>
    </div>
    <ng-template #leer>
      <span class="vorschau-leer">Keine Spalten definiert.</span>
    </ng-template>
  `,
  styles: [`
    .vorschau {
      display: flex;
      flex-wrap: wrap;
      gap: var(--space-2);
    }
    .vorschau-spalte {
      display: flex;
      flex-direction: column;
      gap: 2px;
      min-width: 0;
      padding: 6px 10px;
      border: 1px solid var(--border-color);
      border-radius: var(--radius-sm);
      background: var(--surface-soft);
    }
    .vorschau-kennz {
      border-color: var(--primary);
      background: var(--primary-50);
    }
    .vorschau-name {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-size: var(--fs-sm);
      font-weight: 600;
      color: var(--text-primary);
      white-space: nowrap;
    }
    .vorschau-kennz .vorschau-name { color: var(--primary-dark); }
    .kennz-icon { font-size: 16px; width: 16px; height: 16px; }
    .vorschau-pflicht { margin-left: 2px; color: var(--warn); }
    .vorschau-typ {
      font-size: var(--fs-xs);
      color: var(--text-tertiary);
    }
    .vorschau-leer {
      font-size: var(--fs-sm);
      color: var(--text-tertiary);
    }
  `]
})
export class StrukturVorschauComponent {

  @Input() set struktur(wert: ListenStruktur | null | undefined) {
    this.spalten = strukturSpalten(wert);
  }

  spalten: ListenSpalte[] = [];

  typText(s: ListenSpalte): string {
    return spaltenDatentypText(s.datentyp);
  }

  tooltip(s: ListenSpalte): string {
    const teile = [spaltenDatentypText(s.datentyp)];
    if (s.istKennzeichnung) {
      teile.push('Kennzeichnung – Pflicht, je Liste eindeutig');
    } else if (s.pflicht) {
      teile.push('Pflichtfeld');
    } else {
      teile.push('optional');
    }
    return teile.join(' · ');
  }
}
